module.exports = __webpack_public_path__ + "static/media/and1.708cb22a.webp";